(() => {
  if (window.vssKitLayoutLoaded) return;
  window.vssKitLayoutLoaded = true;

  function enhance(root) {
    root.querySelectorAll('.vss-kit-product [data-vss-kit-description]:not([data-enhanced])').forEach(source => {
      // Work on a clone first: an unexpected description keeps its original content.
      const copy = source.cloneNode(true);
      const children = Array.from(copy.childNodes);
      if (!children.some(node => node.nodeType === 1 && node.tagName === 'H3')) return;
      const fragment = document.createDocumentFragment();
      const intro = document.createElement('div');
      intro.className = 'vss-kit-description__intro';
      fragment.append(intro);
      let target = intro;
      let panel = null;
      children.forEach(node => {
        if (node.nodeType === 1 && node.tagName === 'H3') {
          panel = document.createElement('details');
          panel.className = 'vss-kit-panel';
          const summary = document.createElement('summary');
          summary.append(node);
          target = document.createElement('div');
          target.className = 'vss-kit-panel__body';
          panel.append(summary, target);
          fragment.append(panel);
        } else {
          target.append(node);
        }
      });
      fragment.querySelectorAll('table').forEach(table => {
        const scroll = document.createElement('div');
        scroll.className = 'vss-kit-table-scroll';
        scroll.tabIndex = 0;
        scroll.setAttribute('role', 'region');
        scroll.setAttribute('aria-label', 'Kit components — scroll to see all columns');
        table.replaceWith(scroll);
        scroll.append(table);
        const parent = scroll.closest('details');
        if (parent) {
          parent.classList.add('vss-kit-panel--wide');
          parent.open = true;
        }
      });
      const first = fragment.querySelector('details');
      if (first) first.open = true;
      source.replaceChildren(fragment);
      source.setAttribute('data-enhanced', 'true');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhance(document), { once: true });
  } else enhance(document);
  document.addEventListener('shopify:section:load', event => enhance(event.target));
})();
